import { useState, useEffect } from 'react'
import { TwitterPicker } from 'react-color'
import { themeColor } from 'shared'

export const ColorInput = ({
  onColorChange,
  transparentOption = false,
  value,
}) => {
  const [open, setOpen] = useState(false)

  const handleEnter = (event) => {
    if (event.keyCode === 13) {
      event.preventDefault()
      setOpen(false)
    }
  }

  const colors = [
    themeColor('green-500'),
    themeColor('green-700'),
    themeColor('green-900'),
    themeColor('yellow-400'),
    themeColor('orange-500'),
    themeColor('red-700'),
    themeColor('red-900'),
    themeColor('orange-700'),
    themeColor('blue-400'),
    themeColor('blue-700'),
    themeColor('blue-900'),
    themeColor('purple-400'),
    themeColor('purple-700'),
    themeColor('gray-500'),
    themeColor('gray-700'),
    themeColor('gray-900'),
  ]

  if (transparentOption) {
    colors.push('transparent')
  }

  return <div className='input-group'>
    <div
      style={buildPreviewStyle({ value })}
      onClick={() => setOpen(true)}
      title={`#${value}`}
      tabIndex={0}
    />
    {open && <div style={popoverStyle} onKeyDown={handleEnter}>
      <div style={coverStyle} onClick={() => setOpen(false)} />
      <TwitterPicker
        colors={colors}
        color={value}
        onChangeComplete={(e) => onColorChange({ hex: e.hex.replace("#", "") })}
        styles={TwitterPickerStyles}
      />
    </div>}
  </div>
}

const buildPreviewStyle = ({ value }) => {
  let background
  if (value === 'transparent') {
    background = 'url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAMUlEQVQ4T2NkYGAQYcAP3uCTZhw1gGGYhAGBZIA/nYDCgBDAm9BGDWAAJyRCgLaBCAAgXwixzAS0pgAAAABJRU5ErkJggg==")'
  }
  else {
    background = `#${value === 'transparent' ? '00000000' : value} none repeat scroll 0% 0%`
  }

  return {
    background,
    height: 30,
    width: 30,
    cursor: 'pointer',
    position: 'relative',
    borderRadius: 4,
    margin: '0px 6px 6px 0px',
    border: `1px solid ${themeColor('gray-300')}`
  }
}

const popoverStyle = {
  position: 'absolute',
  zIndex: 2,
  top: 40,
  left: -5,
}

const coverStyle = {
  position: 'fixed',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
}

const TwitterPickerStyles = {
  default: { input: { height: '30px' } }
}

export const StandaloneColorInput = ({ control }) => {
  const [value, setValue] = useState(control.value)

  useEffect(() => control.value = value, [value])

  return <ColorInput onColorChange={({ hex }) => setValue(hex)} value={value} />
}
